import { theme } from '../../styles/theme';

interface LoadingScreenProps {
  cityName: string;
  stage: string;
  progress: number;
  /** Current run round number, or null for practice mode */
  round?: number | null;
}

export function LoadingScreen({ cityName, stage, progress, round = null }: LoadingScreenProps) {
  return (
    <div style={styles.container}>
      <div style={styles.content}>
        <div style={styles.classification}>
          TOP SECRET // <span style={{ color: '#ffdd44' }}>{round != null ? `ROUND ${round}` : 'PRACTICE'}</span>
        </div>
        <h2 style={styles.title}>MISSION BRIEFING</h2>
        <div style={styles.cityName}>{cityName.toUpperCase()}</div>

        <div style={styles.progressBlock}>
          <div style={styles.stage}>{stage}</div>
          <div style={styles.progressTrack}>
            <div
              style={{
                ...styles.progressBar,
                width: `${Math.round(progress * 100)}%`,
              }}
            />
          </div>
          <div style={styles.percent}>{Math.round(progress * 100)}%</div>
        </div>

        <div style={styles.flavorText}>
          <div style={styles.flavorLine}>ESTABLISHING SECURE CONNECTION...</div>
          <div style={styles.flavorLine}>DOWNLOADING OPERATIONAL MAP DATA</div>
          <div style={styles.flavorLine}>ANALYZING TERRAIN AND INFRASTRUCTURE</div>
        </div>
      </div>
    </div>
  );
}

const styles: Record<string, React.CSSProperties> = {
  container: {
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: theme.colors.background,
  },
  content: {
    textAlign: 'center',
    maxWidth: '480px',
    padding: '40px',
  },
  classification: {
    fontSize: '11px',
    letterSpacing: '3px',
    color: theme.colors.accentRed,
    marginBottom: '24px',
    fontWeight: 500,
  },
  title: {
    fontSize: '14px',
    letterSpacing: '6px',
    color: theme.colors.textSecondary,
    marginBottom: '8px',
    fontWeight: 400,
  },
  cityName: {
    fontSize: '36px',
    fontWeight: 700,
    color: theme.colors.textPrimary,
    letterSpacing: '6px',
    marginBottom: '48px',
    fontFamily: theme.fonts.display,
  },
  progressBlock: {
    marginBottom: '48px',
  },
  stage: {
    fontSize: '11px',
    letterSpacing: '1px',
    color: theme.colors.accentGreen,
    marginBottom: '12px',
    minHeight: '16px',
  },
  progressTrack: {
    width: '100%',
    height: '2px',
    background: theme.colors.border,
    borderRadius: '1px',
    overflow: 'hidden',
    marginBottom: '8px',
  },
  progressBar: {
    height: '100%',
    background: theme.colors.accentGreen,
    transition: 'width 0.3s ease',
    boxShadow: `0 0 8px ${theme.colors.accentGreen}40`,
  },
  percent: {
    fontSize: '10px',
    color: theme.colors.textDim,
    letterSpacing: '2px',
  },
  flavorText: {
    display: 'flex',
    flexDirection: 'column',
    gap: '6px',
  },
  flavorLine: {
    fontSize: '10px',
    letterSpacing: '2px',
    color: theme.colors.textDim,
  },
};
